module.exports = {
    TOKEN: `GE_token`,
    USER: 'GE_user',
    EXPENSES: 'GE_expenses',
    GRUOPS: 'GE_groups'
}


// WEBPACK FOOTER //
// ./src/utils/constants.js